import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';
import { LocationSearch } from './LocationSearch';
import { DatePicker } from './DatePicker';
import { GuestPicker } from './GuestPicker';
import { useBooking } from '../hooks/useBooking';
interface SearchBarProps {
  onSearch?: () => void;
}
export function SearchBar({
  onSearch
}: SearchBarProps) {
  const [activeDropdown, setActiveDropdown] = useState<'location' | 'checkIn' | 'checkOut' | 'guests' | null>(null);
  const {
    location,
    checkIn,
    checkOut
  } = useBooking();
  const handleSearch = () => {
    // Basic validation before searching
    if (!location) {
      setActiveDropdown('location');
      return;
    }
    if (!checkIn) {
      setActiveDropdown('checkIn');
      return;
    }
    if (!checkOut) {
      setActiveDropdown('checkOut');
      return;
    }
    if (onSearch) {
      onSearch();
    }
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: 0.2
  }} className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-soft p-2 md:p-3 relative z-20" data-id="element-233">
      <div className="flex flex-col md:flex-row md:items-stretch divide-y md:divide-y-0 md:divide-x divide-gray-100 h-full" data-id="element-234">
        <LocationSearch isOpen={activeDropdown === 'location'} onOpen={() => setActiveDropdown('location')} onClose={() => setActiveDropdown(prev => prev === 'location' ? null : prev)} data-id="element-235" />

        <DatePicker type="checkIn" isOpen={activeDropdown === 'checkIn'} onOpen={() => setActiveDropdown('checkIn')} onClose={() => setActiveDropdown(prev => prev === 'checkIn' ? null : prev)} data-id="element-236" />

        <DatePicker type="checkOut" isOpen={activeDropdown === 'checkOut'} onOpen={() => setActiveDropdown('checkOut')} onClose={() => setActiveDropdown(prev => prev === 'checkOut' ? null : prev)} data-id="element-237" />

        <GuestPicker isOpen={activeDropdown === 'guests'} onOpen={() => setActiveDropdown('guests')} onClose={() => setActiveDropdown(prev => prev === 'guests' ? null : prev)} data-id="element-238" />

        {/* Search Button */}
        <div className="p-2 md:pl-3 shrink-0 flex items-center" data-id="element-239">
          <button onClick={handleSearch} className="w-full md:w-auto h-full bg-luxury-blue hover:bg-blue-600 text-white rounded-xl py-4 md:py-0 px-6 flex items-center justify-center space-x-2 transition-all shadow-md hover:shadow-lg min-h-[48px]" data-id="element-240">
            <Search className="w-5 h-5" data-id="element-241" />
            <span className="font-semibold text-sm" data-id="element-242">Search</span>
          </button>
        </div>
      </div>
    </motion.div>;
}